var map = {
	"./avatar.jpg": "92ef",
	"./bf1_career.jpg": "8cd8",
	"./bf4_campaign.jpg": "238e",
	"./bf4_carrer.jpg": "a071",
	"./bf_4.jpg": "cea4",
	"./bf_5.jpg": "5175",
	"./campaign_mission.jpg": "e7e6",
	"./games/bf1.jpg": "874d",
	"./games/bf4.jpg": "0fdc",
	"./games/bf5.jpg": "f3b1",
	"./games/bfh.jpg": "c0e9",
	"./maps/dawnbreaker.jpg": "6f3b",
	"./maps/defuse.jpg": "8bcc",
	"./maps/golmud-railway.jpg": "52c0",
	"./maps/lancang-dam.jpg": "10fa",
	"./maps/operation-locker.jpg": "c639",
	"./maps/operation-whiteout.jpg": "8d9b",
	"./maps/propaganda.jpg": "db7e",
	"./maps/siege-of-shanghai.jpg": "d5e1",
	"./menu_bg.jpg": "5aef",
	"./multiplayer-select/quickmatch.jpg": "792a",
	"./multiplayer-select/server_browser.jpg": "7718",
	"./multiplayer-select/squad_join.jpg": "8477",
	"./multiplayer-select/test_range.jpg": "fdbf7",
	"./news/chapter-6.jpg": "5359",
	"./news/fan-made-video.jpg": "35d2",
	"./news/jungle.jpg": "d251",
	"./news/red-airplane.jpg": "5b11",
	"./news/summer.jpg": "8d4c",
	"./news/wake-island.jpg": "19d3",
	"./news/winners.jpg": "7936",
	"./quickmatch/CO.jpg": "bee9",
	"./quickmatch/COL.jpg": "4b12",
	"./quickmatch/CQ.jpg": "d467",
	"./quickmatch/LSB.jpg": "59ea",
	"./quickmatch/NO.jpg": "ae14",
	"./quickmatch/NOI.jpg": "04a6",
	"./quickmatch/NOL.jpg": "0f57",
	"./quickmatch/TB.jpg": "1975",
	"./watch/beginners-guide-to-bf4-by-asal.jpg": "d534",
	"./watch/better-squad.jpg": "aad4",
	"./watch/learn-about-new-weapons.jpg": "dda5",
	"./watch/learn-bf4-basics-with-oshy.jpg": "c460",
	"./watch/new-into-the-jungle-trailer.jpg": "d4eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";